jQuery( document ).ready( function( $ ) {

    'use strict';

    /**
     * Prepare to handle routes and parameters.
     */
    var uri = new YouAreI(window.location.href);

    var embed = $('.timeline.not_embed').length === 0;
    /**
     * Timeline namespace
     * @type {Object}
     */
    var Timeline = Timeline || {};

    //var ArtifactViewer = window.ArtifactViewer;

    /**
     * $timelinewrap is the major wrapping element for the others we'll be working with.
     * @type {Element}
     *
     *  Structure of major page elements is as follows:
     *
     *  <section class="timeline-wrapper">  $timelinewrap - Wrapping component
     *    <div class="main"></div>          $main - Title and Year display area
     *    <div id="year-ctl"></div>         Dragdealer dragging component
     *    <div id="event-ctl"></div>        General controls for the event view
     *    <ul  id="timeline"></ul>          Main timeline element, contains events
     *    <div class="event-viewer"></div>  Displays event being viewed
     *  </section>
     *
     *  The visibility of elements should be determined/controlled
     *  by the class 'state-event' or 'state-timeline' whenever possible
     */ 
    var $timelinewrap   = $('#timeline');
    var $main           = $timelinewrap.find('#timeline-date-in-slider');
    var $timeline       = $timelinewrap.find('#timeline-filmstrip');
    var $artifactViewer = $timelinewrap.find('#timeline-event-viewer');
    var $filters        = $timelinewrap.find('#timeline-filters');
    var $eventwrap      = $timelinewrap.find('.timeline__filmstrip-cell');
    var previousTimelineCell;

    /**
     * Create an "index" of event's years, keyed by their relative spatial
     * position within the timeline, as an incremented integer.
     *
     * Some years may span two or more properties of the object, for example,
     * But each year should be present in at least one property
     *
     * @return {Object} Event years keyed by an incrementing index
     */
    Timeline.buildIndex = function() {

        // Create an empty object
        var index = {};
        // Initialize our index at 0
        var position = 0;

        /**
         * Given a year value and a number of times this year should be
         * inserted into the index, increment the index, and add this
         * year in as the property's value.
         *
         * @param {String} year  Pulled from the event's data attribute 'year'
         * @param {Number} times How many properties this year should span
         */
        var addSpatialYearIndex = function(year, times) {
            for (var i = 0; i < times; i++) {
                position += 1;
                index[position] = year;
            }
        };

        /**
         * Loop over each '.event' element, find its year value.
         * If this is a "tall" event, it should span two properties in the year index.
         */
        $timeline.find('.timeline__filmstrip-cell').each( function() {

            var $this = $(this);
            var year = $this.attr('data-year');
            addSpatialYearIndex(year, 1);

        });

        return index;

    };

    /**
     * Global to store last year text visible in the timeline.
     * @type {String}
     */
    Timeline.last = '';

    Timeline.triggerEventView = function($timelineCell) {

        $('.timeline__filmstrip-cell').removeClass('active');
        updateViewer($timelineCell);


        // @todo-artifact-viewer ArtifactViewer.makeViewer($template.find('.artifact-group'));



        /**
         * Is it 4 digits? Returns Array or Null (truthy or falsy)
         * @param  {string}     text A given string
         * @return {Array|null}      Truthy boolean if it matches YYYY format.
         */
        // function textIsYear(text) {
        //     var re = /^\d{4}$/;
        //     return re.exec(text);
        // }

        // if (textIsYear($main.text())) {
        //     // global
        //     Timeline.last = $main.text();
        // }

        // $main.text($event.find('.timeline-tile__title').text());

        $('.timeline__event-viewer').show();

        $timelineCell.addClass('active');

    };

  /**
   * This is a bit goofy, but because the MAV JavaScript (see tilezoom.js) relies on
   * each viewer having a unique ID, when a user requests the multi-artifact viewer on
   * the timeline, the easiest thing is to move the MAV markup from the timeline into
   * the single container we have for the viewer, then back again when a new viewer is
   * requested. This function handles all that.
   *
   * @param $timelineCell
   *     The cell of the Historical Event tile in the timeline that was clicked.
   */
    var updateViewer = function($timelineCell) {
      if (previousTimelineCell !== undefined) {
          // Move the HTML currently in the visible container back to where it came from.
          unloadViewer();

          // Load in the new HTML.
          loadViewer($timelineCell);
      }
      else {
          // First time the viewer was requested. Load in the HTML.
          loadViewer($timelineCell);
      }

      // In both situations, record a reference to the current timeline cell.
      previousTimelineCell = $timelineCell.selector;
    };

  /**
   * Moves the contents of the multi-artifact viewer back to the proper spot
   * in the timeline.
   */
  var unloadViewer = function() {
      $artifactViewer.find('.timeline-tile__event')
        .appendTo($(previousTimelineCell).find('.timeline-tile'))
        .hide();
    };

  /**
   * Loads a new multi-artifact viewer into the container.
   *
   * @param $timelineCell
   *    The cell of the Historical Event tile in the timeline that was clicked.
   */
    var loadViewer = function($timelineCell) {
      $timelineCell.find('.timeline-tile__event')
        .appendTo($artifactViewer)
        .show();
    };

    /**
     * Utility function to return the last property (key, not value) in an object.
     * @param  {Object} obj
     * @return {String} Last (numerical) key in object
     */
    var lastProperty = function(obj) {
        var keys = Object.keys(obj);
        return keys[keys.length - 1];
    };

    var initialize = function($timeline) {

        // If the timeline isn't present, return;
        if ($timeline.length <= 0) {
            return;
        }

        /**
         * Spatial index for use in drag control
         * @type {Object}
         */
        var INDEX = Timeline.buildIndex();

        /**
         * Convert the last property to a number,
         * value is length of spatial index for mapping to drag control
         * @type {Number}
         */
        var COUNT = parseFloat(lastProperty(INDEX));

        /**
         * Initialize filter state as an empty array (it will house objects)
         * @type {Array}
         */
        var FilterState = [];

        // Set initial text to the first year in the INDEX
        $main.text(INDEX[1]);
        var availWidth = $('.timeline__filmstrip-nav').outerWidth();
        var tileWidth = $('.timeline__filmstrip-cell')[0].getBoundingClientRect().width;
        var allCellsWidth = tileWidth * COUNT;
        var endWidth = allCellsWidth - availWidth;
        $('.timeline__filmstrip-nav').width(allCellsWidth);

        var redrawWidth = function(x) {
            var valuetest = -x * endWidth;
            var newvalue = Math.floor(valuetest/tileWidth) * tileWidth;
            $timeline.css('margin-left', newvalue);
        };

        var COUNT2 = COUNT + 1;

        var drag = new Dragdealer('timeline-slider', {
            loose: false,
            horizontal: true,
            vertical: false,
            xPrecision: availWidth,
            steps: COUNT2,
            animationCallback: function(x, y) {
                redrawWidth(x);
                var step = Math.round(x*COUNT) + 1;

                if (step > COUNT) {
                    step = COUNT;
                }
                $main.text(INDEX[step]);
            }
        });

        $('.timeline__filmstrip-next').on('click', function(event) {
            drag.setStep(drag.getStep()[0] + 4, 0);
        });

        $('.timeline__filmstrip-prev').on('click', function(event) {
            drag.setStep(drag.getStep()[0] - 4, 0);
        });

        // SHOW EVENT
        $timelinewrap.on('click', '.timeline__filmstrip-cell', function(event) {

            event.preventDefault();

            var index = $(this).index() + 1;

            if (typeof index === 'number' && indexIsInTimeline(index)) {
                History.pushState(
                    {
                        event: index
                    },
                    null,
                    !embed ? '?event=' + index : null
                );
            }

            // this is duplicative, but otherwise the first tile in the timeline doesnt show
            // event info on click. Its not triggering 'onstatechange'.
            Timeline.triggerEventView($( ".timeline__filmstrip-cell:eq(" + (index - 1) + ")" ));
              $.smoothScroll({
                scrollTarget: '#timeline-event-viewer'
              });
        });

        window.onstatechange = function() {
            var params = History.getState().data;
            if (params.home || $.isEmptyObject(params) || invalidEventID(params.event)) {
                showTimeline();
                redrawWidth(drag.getValue()[0]);
            } else {
                loadCurrentEvent(params.event);
            }
        };

        var invalidEventID = function(event_id) {
            return isNaN(parseInt(event_id, 10));
        };

        var indexIsInTimeline = function(index) {
            return index >= 1 && index <= COUNT;
        };

        // SHOW TIMELINE
        // $timelinewrap.on('click', '.back-btn', function(event){

        //     History.pushState(
        //         {
        //             home: true
        //         },
        //         null,
        //         !embed ? '?home=' + true : null
        //     );

        //     availWidth = $timeline.outerWidth();
        //     drag.reflow();
        //     redrawWidth(drag.getValue()[0]);
        // });

        // var showTimeline = function() {

        //     //ArtifactViewer.eradicateTilezooms();
        //     //ArtifactViewer.eradicateVideos();

        //     drag.enable();

        //     //$('.state-timeline').show();

        //     var $active = $('.timeline__filmstrip-cell.active');

        //     $active.find('.timeline-tile__link').off('click');

        //     $active.removeClass('active');

        //     $main.text(Timeline.last);

        //     $('.timeline__event-viewer').hide();

        // };

        // $timelinewrap.on('click', '.nav-btn', function(event){

        //     //ArtifactViewer.eradicateTilezooms();
        //     //ArtifactViewer.eradicateVideos();

        //     var direction   = $(this).attr('data-direction');
        //     var target      = $(this).attr('data-target');
        //     var event_id;
        //     var $active     = $('.timeline__filmstrip-cell.active');
        //     var statelink;

        //     if (target) {
        //         event_id = target;
        //     } else if (direction) {
        //         event_id = parseInt($active.index(), 10) + parseInt(direction, 10) + 1;
        //     }

        //     $active.removeClass('active');

        //     statelink = !embed ? '?event=' + event_id : null;

        //     History.pushState(
        //         {
        //             event: event_id
        //         },
        //         null,
        //         statelink
        //     );
        // });

        var loadEventByIndex = function(index) {
            if (typeof index === 'number') {
                Timeline.triggerEventView($( ".timeline__filmstrip-cell:eq(" + index + ")" ));
            }
        };

        var loadCurrentEvent = function(event_id) {
            if (!invalidEventID(event_id)) {
                loadEventByIndex(event_id - 1);
            }
        };

        var themeSelects = function() {
            $('.timeline__refine-group select').chosen().change(function () {
                var $this = $(this);
                var taxonomy = $(this).parent().attr('data-taxonomy');

                FilterState[taxonomy] = $this.val();
                applyFilters(FilterState);
            });
        };

    //     var applyFilters = function(state) {

    //         var taxonomies = _.keys(state);

    //         $eventwrap.each(function(index, el) {

    //             var exclusive = !_.every(taxonomies, function(taxonomy) {
    //                 var data = $(el).attr('data-' + taxonomy);
    //                 var filterstate = _.map(state[taxonomy], function(item) {
    //                     return Number(item);
    //                 });
    //                 // short circuit if
    //                 // we have no filters set
    //                 return filterstate.length === 0 ||
    //                 // or the data exists on this event
    //                 // and there's no difference produced between it and the state
    //                 typeof data !== 'undefined' &&
    //                 _.difference(filterstate, JSON.parse(data)).length === 0;
    //             });

    //             if (exclusive) {
    //                 $(el).addClass('u-hidden');
    //             } else {
    //                 $(el).removeClass('u-hidden');
    //             }

    //         });

    //         availWidth = $timeline.outerWidth();
    //         drag.reflow();
    //         redrawWidth(drag.getValue()[0]);
    //     };
    //     loadCurrentEvent(uri.query_get().event);
    //     themeSelects();

    };

    initialize($timeline);

});
